import { render, staticRenderFns } from "./ProductTableHeader.vue?vue&type=template&id=3072f5dc&scoped=true"
import script from "./ProductTableHeader.vue?vue&type=script&lang=js"
export * from "./ProductTableHeader.vue?vue&type=script&lang=js"
import style0 from "./ProductTableHeader.vue?vue&type=style&index=0&id=3072f5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3072f5dc",
  null
  
)

export default component.exports